/**
 * Tinymce Chunk Splitter.
 *
 * Splits tiny and our own specific tiny code e.g plugins, languages into a bundle.
 *
 * Import all plugins which are purerely tiny and languages through calling this function.
 * Plugins that need to have context of SON (Linkchooser, sonHelp) should use the Plugin.tsx structure
 * For Code-Splitting documentation @see https://webpack.js.org/guides/code-splitting/#dynamic-imports.
 * css will be loaded as assets as we dont import css as strings.
 *
 * Tinymce plugins and themes will be loaded via tiny itself. Those plugins need to be copied to wher static files are.
 */
export async function importTinyDynamically() {
  const { default: tinymce } = await import(/* webpackChunkName: "tinymce" */ 'tinymce');

  /* Import son custom plugins and langs plugins */
  await import(/* webpackChunkName: "tinymce" */ '../langs/de');
  await import(/* webpackChunkName: "tinymce" */ '../langs/de-overrides');
  await import(/* webpackChunkName: "tinymce" */ '../plugins/sonLang/plugin');
  await import(/* webpackChunkName: "tinymce" */ '../plugins/sonHilight/plugin');
  await import(/* webpackChunkName: "tinymce" */ '../plugins/sonAbbr/plugin');
  await import(/* webpackChunkName: "tinymce" */ '../plugins/Fullscreen/plugin');
  await import(/* webpackChunkName: "tinymce" */ '../plugins/Emojis/plugin');
  await import(/* webpackChunkName: "tinymce" */ '../plugins/Mentions/plugin');

  return tinymce;
}
